var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Link } from "react-router-dom";
import { Button, Dimmer, Header, Input, Loader, Menu, Message, Modal, Pagination, Table } from "semantic-ui-react";
import { AppPaths } from "../AppConfig";
import { API_SVC_BASE_URL } from "../Config";
import { debounce } from "../kit/rna-cish/ProKitForm";
import { getWithAuthn } from "../RequestHelpers";
import { displayLocalTimestamp } from "./AllOrdersPage";
var AllUsersPage = /** @class */ (function (_super) {
    __extends(AllUsersPage, _super);
    function AllUsersPage(props) {
        var _this = _super.call(this, props) || this;
        _this.loadCurrentUserPage = function () {
            var path = "/admin/users/all?pageNumber=" + encodeURIComponent(_this.state.currentPage - 1);
            if (_this.state.userFilter !== "") {
                path = path + ("&userFilter=" + encodeURIComponent(_this.state.userFilter));
            }
            _this.setState({ loading: true }, function () {
                getWithAuthn(path)
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            error: false,
                            users: resp.users,
                            totalPages: resp.totalPages
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load users: " + rej);
                });
            });
        };
        _this.loadUserEmail = function (userId) {
            return function () {
                var path = "/admin/users/email/id/" + encodeURIComponent(userId);
                _this.setState({ loading: true }, function () {
                    getWithAuthn(path)
                        .then(function (resp) {
                        if (resp.status === 200) {
                            return resp.json();
                        }
                        else {
                            return undefined;
                        }
                    })
                        .then(function (resp) {
                        if (resp === undefined) {
                            _this.setState({
                                loading: false,
                                error: true
                            });
                        }
                        else {
                            _this.setState({
                                loading: false,
                                loadedUserEmail: resp.email
                            });
                        }
                    })
                        .catch(function (rej) {
                        console.error("Couldn't load users: " + rej);
                    });
                });
            };
        };
        _this.clearLoadedUserEmail = function () {
            _this.setState({
                loadedUserEmail: '',
                error: false
            });
        };
        _this.onUserSearchChange = function (event, data) {
            var str = data.value;
            _this.setState(function () {
                return {
                    userFilter: str,
                    currentPage: 1,
                };
            }, _this.loadCurrentUserPage);
        };
        _this.onPageChange = function (_, data) {
            var path = "/admin/users/all?pageNumber=" + encodeURIComponent(data.activePage - 1);
            if (_this.state.userFilter !== "") {
                path = path + ("&userFilter=" + encodeURIComponent(_this.state.userFilter));
            }
            _this.setState({ loading: true }, function () {
                getWithAuthn(path)
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            users: resp.users,
                            currentPage: data.activePage,
                            totalPages: resp.totalPages
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load catalog: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            error: false,
            users: [],
            userFilter: '',
            pageNumber: 0,
            totalPages: 1,
            currentPage: 1,
            loadedUserEmail: ''
        };
        return _this;
    }
    AllUsersPage.prototype.render = function () {
        var _this = this;
        return React.createElement(React.Fragment, null,
            React.createElement(Menu, null,
                React.createElement(Menu.Item, null,
                    React.createElement(Input, { onChange: debounce(this.onUserSearchChange, 300), placeholder: 'User Name or User ID' })),
                React.createElement(Menu.Item, null,
                    React.createElement(Pagination, { totalPages: this.state.totalPages, ellipsisItem: null, onPageChange: this.onPageChange, activePage: this.state.currentPage }))),
            React.createElement(Dimmer.Dimmable, { as: 'div', id: "non-header-portion" },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                React.createElement(Header, null,
                    "Users",
                    React.createElement("a", { href: API_SVC_BASE_URL + "/admin/users/all-users-csv" },
                        React.createElement(Button, { label: "Download", icon: 'download', labelPosition: "left", style: { marginLeft: '5px' } }))),
                this.state.error &&
                    React.createElement(Message, { negative: true }, "Users could not be loaded."),
                React.createElement(Table, { striped: true, celled: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Name"),
                            React.createElement(Table.HeaderCell, { title: 'Account Email' }, "Account Email"),
                            React.createElement(Table.HeaderCell, { title: 'Shipping address country code' }, "Country"),
                            React.createElement(Table.HeaderCell, null, "Category"),
                            React.createElement(Table.HeaderCell, { title: 'Discount percentage' }, "RNA-FISH Catalog Probe"),
                            React.createElement(Table.HeaderCell, { title: 'Discount percentage' }, "RNA-FISH Custom Probe"),
                            React.createElement(Table.HeaderCell, { title: 'Discount percentage' }, "RNA-FISH Amplifier"),
                            React.createElement(Table.HeaderCell, { title: 'Discount percentage' }, "RNA-FISH Buffers"),
                            React.createElement(Table.HeaderCell, { title: 'Discount percentage' }, "2\u00BAIHC Probe"),
                            React.createElement(Table.HeaderCell, { title: 'Discount percentage' }, "2\u00BAIHC Buffers"),
                            React.createElement(Table.HeaderCell, { title: 'Discount percentage' }, "RNA-ISH Catalog Probe"),
                            React.createElement(Table.HeaderCell, { title: 'Discount percentage' }, "RNA-ISH Custom Probe"),
                            React.createElement(Table.HeaderCell, { title: 'Discount percentage' }, "RNA-ISH Amplifier"),
                            React.createElement(Table.HeaderCell, { title: 'Discount percentage' }, "RNA-ISH Buffers"),
                            React.createElement(Table.HeaderCell, null, "Created"))),
                    React.createElement(Table.Body, null, this.state.users.map(function (o, index) {
                        return React.createElement(Table.Row, { key: index },
                            React.createElement(Table.Cell, null,
                                React.createElement(Link, { to: AppPaths.ADMIN_USER_BASE + "/" + o.id }, o.name)),
                            React.createElement(Table.Cell, null,
                                React.createElement(Modal, { trigger: React.createElement(Button, { icon: 'eye', onClick: _this.loadUserEmail(o.id) }), closeIcon: true, closeOnDimmerClick: true, closeOnEscape: true, onClose: _this.clearLoadedUserEmail },
                                    React.createElement(Modal.Header, null,
                                        "User Email - ",
                                        o.name),
                                    React.createElement(Modal.Content, null,
                                        React.createElement("a", { href: "mailto:" + _this.state.loadedUserEmail }, _this.state.loadedUserEmail)))),
                            React.createElement(Table.Cell, null, o.countryCode),
                            React.createElement(Table.Cell, null, o.category),
                            React.createElement(Table.Cell, null, displayDiscountPct(o.discounts.rnaFishProbeSetCatalog)),
                            React.createElement(Table.Cell, null, displayDiscountPct(o.discounts.rnaFishProbeSetCustom)),
                            React.createElement(Table.Cell, null, displayDiscountPct(o.discounts.rnaFishAmplifier)),
                            React.createElement(Table.Cell, null, displayDiscountPct(o.discounts.rnaFishBuffers)),
                            React.createElement(Table.Cell, null, displayDiscountPct(o.discounts.ihc2Probe)),
                            React.createElement(Table.Cell, null, displayDiscountPct(o.discounts.ihc2Buffers)),
                            React.createElement(Table.Cell, null, displayDiscountPct(o.discounts.rnaCishProbeSetCatalog)),
                            React.createElement(Table.Cell, null, displayDiscountPct(o.discounts.rnaCishProbeSetCustom)),
                            React.createElement(Table.Cell, null, displayDiscountPct(o.discounts.rnaCishAmplifier)),
                            React.createElement(Table.Cell, null, displayDiscountPct(o.discounts.rnaCishBuffers)),
                            React.createElement(Table.Cell, null, displayLocalTimestamp(o.createdAt)));
                    })))));
    };
    AllUsersPage.prototype.componentDidMount = function () {
        this.loadCurrentUserPage();
    };
    return AllUsersPage;
}(React.PureComponent));
export default AllUsersPage;
var displayDiscountPct = function (discount) {
    return React.createElement(React.Fragment, null, discount.length > 0 ? discount + "%" : '');
};
//# sourceMappingURL=AllUsersPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AllUsersPage.js
// module id = 1203
// module chunks = 0